// ONPULSE V90 — Fast cart bundle guard for Choose size later
// Keeps these two cart items inseparable:
// - Onpulse Ring 3 Voucher
// - Free Sizing Kit

// Adds:
// - faster sync after cart changes
// - center toast
// - checkout guard so customers cannot proceed with only one bundle item

  (function () {
    if (window.__onpulseBundleGuardLoaded) return;
    window.__onpulseBundleGuardLoaded = true;

    var VOUCHER_VARIANT_ID = 57505027260799;
    var SIZING_KIT_VARIANT_ID = 57450847895935;

    var isSyncing = false;
    var pendingSyncTimer = null;
    var lastToastAt = 0;

    function cartRoot() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    }

    function isCartUrl(url) {
      url = String(url || "");
      return (
        url.indexOf("/cart/change") !== -1 ||
        url.indexOf("/cart/update") !== -1 ||
        url.indexOf("/cart/clear") !== -1 ||
        url.indexOf("/cart/add") !== -1
      );
    }

    function getCart() {
      return fetch(cartRoot() + "cart.js", {
        method: "GET",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      }).then(function (response) {
        if (!response.ok) throw new Error("Could not read cart");
        return response.json();
      });
    }

    function normalizedText(value) {
      return String(value || "").toLowerCase();
    }

    function itemText(item) {
      if (!item) return "";
      return [
        item.handle,
        item.product_handle,
        item.product_title,
        item.title,
        item.variant_title
      ].map(normalizedText).join(" ");
    }

    function isVoucherLine(item) {
      if (!item || Number(item.quantity || 0) <= 0) return false;
      var text = itemText(item);
      return Number(item.variant_id || item.id || 0) === VOUCHER_VARIANT_ID && text.indexOf("voucher") !== -1;
    }

    function isSizingKitLine(item) {
      if (!item || Number(item.quantity || 0) <= 0) return false;
      var text = itemText(item);
      return Number(item.variant_id || item.id || 0) === SIZING_KIT_VARIANT_ID && (text.indexOf("sizing kit") !== -1 || text.indexOf("free-sizing-kit") !== -1 || text.indexOf("sizing-kit") !== -1);
    }

    function findVoucherLine(cart) {
      if (!cart || !cart.items) return null;
      return cart.items.find(isVoucherLine) || null;
    }

    function findSizingKitLine(cart) {
      if (!cart || !cart.items) return null;
      return cart.items.find(isSizingKitLine) || null;
    }

    function removeLineByKey(lineKey) {
      return fetch(cartRoot() + "cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: ["mini-cart", "main-cart"],
          sections_url: window.location.pathname
        })
      }).then(function (response) {
        if (!response.ok) throw new Error("Could not remove paired bundle item");
        return response.json();
      });
    }

    function showBundleRemovedMessage() {
      var now = Date.now();

      if (now - lastToastAt < 900) return;
      lastToastAt = now;

      var messageLine1 = "Sizing kit and voucher must stay together.";
      var messageLine2 = "Both are needed for Choose size later.";

      var existing = document.querySelector("[data-onpulse-bundle-toast]");
      if (existing) existing.remove();

      var toast = document.createElement("div");
      toast.setAttribute("data-onpulse-bundle-toast", "true");
      toast.setAttribute("role", "status");
      toast.innerHTML = '<div>' + messageLine1 + '</div><div>' + messageLine2 + '</div>';

      toast.style.position = "fixed";
      toast.style.left = "50%";
      toast.style.top = "50%";
      toast.style.transform = "translate(-50%, -50%) scale(0.98)";
      toast.style.zIndex = "999999";
      toast.style.maxWidth = "calc(100vw - 44px)";
      toast.style.width = "min(360px, calc(100vw - 44px))";
      toast.style.padding = "14px 16px";
      toast.style.borderRadius = "16px";
      toast.style.background = "rgba(10,16,48,0.97)";
      toast.style.border = "1px solid rgba(49,197,208,0.44)";
      toast.style.boxShadow = "0 18px 45px rgba(0,0,0,0.45), 0 0 24px rgba(49,197,208,0.10)";
      toast.style.color = "#ffffff";
      toast.style.fontSize = "13px";
      toast.style.lineHeight = "1.38";
      toast.style.fontWeight = "600";
      toast.style.textAlign = "center";
      toast.style.opacity = "0";
      toast.style.transition = "opacity 180ms ease, transform 180ms ease";
      toast.style.pointerEvents = "none";
      toast.style.backdropFilter = "blur(10px)";
      toast.style.webkitBackdropFilter = "blur(10px)";

      document.body.appendChild(toast);

      window.requestAnimationFrame(function () {
        toast.style.opacity = "1";
        toast.style.transform = "translate(-50%, -50%) scale(1)";
      });

      window.setTimeout(function () {
        toast.style.opacity = "0";
        toast.style.transform = "translate(-50%, -50%) scale(0.98)";
        window.setTimeout(function () {
          if (toast && toast.parentNode) toast.parentNode.removeChild(toast);
        }, 220);
      }, 3400);
    }

    function refreshCartUi(showMessage) {
      if (showMessage) showBundleRemovedMessage();

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
    }

    function cartHasBrokenBundle(cart) {
      var voucherLine = findVoucherLine(cart);
      var kitLine = findSizingKitLine(cart);

      return {
        broken: !!((voucherLine && !kitLine) || (!voucherLine && kitLine)),
        voucherLine: voucherLine,
        kitLine: kitLine
      };
    }

    function syncBundleItems(options) {
      options = options || {};
      var showMessage = !!options.showMessage;

      if (isSyncing && !options.force) {
        return Promise.resolve(false);
      }

      isSyncing = true;

      return getCart()
        .then(function (cart) {
          var state = cartHasBrokenBundle(cart);

          if (!state.broken) {
            return false;
          }

          var lineToRemove = state.voucherLine || state.kitLine;
          if (!lineToRemove || !lineToRemove.key) return false;

          return removeLineByKey(lineToRemove.key)
            .then(function () {
              refreshCartUi(showMessage);
              return true;
            });
        })
        .catch(function (error) {
          console.warn("[Onpulse] Bundle guard sync failed:", error);
          return false;
        })
        .finally(function () {
          isSyncing = false;
        });
    }

    function scheduleSync(delay, showMessage) {
      window.clearTimeout(pendingSyncTimer);
      pendingSyncTimer = window.setTimeout(function () {
        syncBundleItems({ showMessage: !!showMessage });
      }, typeof delay === "number" ? delay : 40);
    }

    function protectCheckout(event) {
      var target = event.target && event.target.closest ? event.target.closest('a, button, input[type="submit"]') : null;
      if (!target) return;

      var href = target.getAttribute && target.getAttribute("href");
      var name = target.getAttribute && target.getAttribute("name");
      var form = target.form || (target.closest && target.closest("form"));
      var action = form && form.getAttribute ? form.getAttribute("action") : "";

      var looksLikeCheckout =
        (href && href.indexOf("/checkout") !== -1) ||
        (action && action.indexOf("/cart") !== -1 && String(name || "").toLowerCase() === "checkout") ||
        (String(name || "").toLowerCase() === "checkout") ||
        target.matches('[data-cart-checkout], [name="checkout"], .cart__checkout-button, button[name="checkout"]');

      if (!looksLikeCheckout) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      target.setAttribute("aria-busy", "true");
      if ("disabled" in target) target.disabled = true;

      getCart()
        .then(function (cart) {
          var state = cartHasBrokenBundle(cart);

          if (state.broken) {
            return syncBundleItems({ showMessage: true, force: true }).then(function () {
              return false;
            });
          }

          return true;
        })
        .then(function (canCheckout) {
          if (!canCheckout) return;

          if (href && href.indexOf("/checkout") !== -1) {
            window.location.href = href;
          } else if (form && form.submit) {
            form.submit();
          } else {
            window.location.href = cartRoot() + "checkout";
          }
        })
        .catch(function (error) {
          console.warn("[Onpulse] Checkout guard failed:", error);
          showBundleRemovedMessage();
          scheduleSync(0, false);
        })
        .finally(function () {
          window.setTimeout(function () {
            target.removeAttribute("aria-busy");
            if ("disabled" in target) target.disabled = false;
          }, 700);
        });
    }

    document.addEventListener("click", protectCheckout, true);
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart"]')) return;
      var submitter = event.submitter;
      var name = submitter && submitter.getAttribute ? submitter.getAttribute("name") : "";
      if (String(name || "").toLowerCase() !== "checkout") return;
      protectCheckout(event);
    }, true);

    document.addEventListener("change", function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest("cart-drawer, .mini-cart, .drawer, form[action*='/cart'], .cart")) {
        scheduleSync(25, true);
      }
    }, true);

    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest("[data-quantity-selector], [data-action='decrease-quantity'], [data-action='increase-quantity'], [href*='/cart/change'], cart-drawer, .mini-cart, .drawer, .cart")) {
        scheduleSync(80, true);
      }
    }, true);

    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartUrl(url)) {
          response.clone().json().catch(function () {}).finally(function () {
            scheduleSync(20, true);
          });
        }

        return response;
      });
    };

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__onpulseCartUrl = isCartUrl(url);
      return originalOpen.apply(this, arguments);
    };

    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__onpulseCartUrl) {
        this.addEventListener("loadend", function () {
          scheduleSync(20, true);
        });
      }

      return originalSend.apply(this, arguments);
    };

    window.setTimeout(function () {
      scheduleSync(0, false);
    }, 250);
  })();